export type TourId =
  | 'welcome'
  | 'website'
  | 'forms'
  | 'crm'
  | 'todos'
  | 'calendar'
  | 'analytics'
  | 'profile'
  | 'ai-assistant';

export type TourCategory = 'core' | 'productivity' | 'marketing' | 'settings';

export interface TourStep {
  id: string;
  target: string;        // CSS selector or data-tour attribute
  title: string;
  content: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
  action?: 'click' | 'navigate';
  actionTarget?: string; // URL or selector to click
}

export interface TourDefinition {
  id: TourId;
  name: string;
  description: string;
  icon: string;
  category: TourCategory;
  sort_order: number;
  steps: TourStep[];
}

export interface UserTourProgress {
  id: string;
  user_id: string;
  tour_id: TourId;
  current_step: number;
  completed: boolean;
  completed_at: string | null;
  started_at: string;
}

export interface UserOnboarding {
  user_id: string;
  has_seen_welcome: boolean;
  full_tour_completed: boolean;
  full_tour_completed_at: string | null;
  last_tour_id: TourId | null;
  created_at: string;
  updated_at: string;
}

export interface TourState {
  isActive: boolean;
  currentTour: TourDefinition | null;
  currentStepIndex: number;
  isLoading: boolean;
}

// Tour route mapping for navigation
export const TOUR_ROUTES: Record<TourId, string> = {
  'welcome': '/dashboard',
  'website': '/site/pages',
  'forms': '/forms',
  'crm': '/leads',
  'todos': '/todos',
  'calendar': '/calendar',
  'analytics': '/analytics',
  'profile': '/profile',
  'ai-assistant': '/dashboard',
};

// Full tour sequence
export const FULL_TOUR_SEQUENCE: TourId[] = [
  'welcome',
  'website',
  'forms',
  'crm',
  'todos',
  'ai-assistant',
];
